export { getCountryCode };

// import axios from "axios";
import {
  pol_nl,
  pol_de_nl,
  pol_na,
  pol_as,
  pol_aus,
  pol_europe,
  pol_de_rough,
  pol_fr_rough,
  pol_uk_rough,
  pol_be_rough,
  pol_sc_rough,
  pol_es_rough,

} from "@/utils/polygon_de_nl";
import { robustPointInPolygon } from "@/utils/point_in_p";

async function getCountryCode(lon, lat) {
  // let startTime = performance.now();

  // let pol = pol_de_nl.coordinates;
  let in_nl = robustPointInPolygon(pol_nl.coordinates, [lon, lat]);
  let in_de_rough = robustPointInPolygon(pol_de_rough.coordinates, [lon, lat]);
  let in_fr_rough = robustPointInPolygon(pol_fr_rough.coordinates, [lon, lat]);

  let in_uk_rough = robustPointInPolygon(pol_uk_rough.coordinates, [lon, lat]);
  let in_be_rough = robustPointInPolygon(pol_be_rough.coordinates, [lon, lat]);
  let in_sc_rough = robustPointInPolygon(pol_sc_rough.coordinates, [lon, lat]);
  let in_es_rough = robustPointInPolygon(pol_es_rough.coordinates, [lon, lat]);

  let in_de_nl = robustPointInPolygon(pol_de_nl.coordinates, [lon, lat]);
  let in_na = robustPointInPolygon(pol_na.coordinates, [lon, lat]);
  let in_as = robustPointInPolygon(pol_as.coordinates, [lon, lat]);
  let in_aus = robustPointInPolygon(pol_aus.coordinates, [lon, lat]);

  let in_europe = robustPointInPolygon(pol_europe.coordinates, [lon, lat]);
  // let endTime = performance.now();
  console.log(
    ":: debug:  res, lon, lat: ",
    in_de_nl,
    in_de_rough,
    in_fr_rough,
    in_uk_rough,
    in_be_rough,
    in_sc_rough,
    in_es_rough,
    in_nl,
    in_europe,
    in_na,
    in_as,
    in_aus,
    lon,
    lat
  );

  // Switching HR domains on/off is config-driven (backend HRCountries /
  // HRAliases via /api/datasource-config), not done here: this function only
  // reports which polygon area the point is in.

  if (in_de_nl == -1 && in_nl == -1) {
    return "nl";
  } else if (in_de_rough == -1) {
    return "de";
  } else if (in_fr_rough == -1) {
    console.log("+++++++++++++++++++++++++++++++++ FR!");
    return "fr";
  } else if (in_uk_rough == -1) {
    console.log("+++++++++++++++++++++++++++++++++ UK!");
    return "bi";
  } else if (in_be_rough == -1) {
    console.log("+++++++++++++++++++++++++++++++++ BE!");
    return "be";
  } else if (in_sc_rough == -1) {
    console.log("+++++++++++++++++++++++++++++++++ SC!");
    return "sc";
  } else if (in_es_rough == -1) {
    console.log("+++++++++++++++++++++++++++++++++ ES!");
    return "ip";
  } else if (in_de_nl == -1 && in_nl != -1) {
    // return "de";
    return "eu"; // otherwise it leads to a bug - global forecast update time returned
  } else if (in_europe == -1) {
    console.log("+++++++++++++++++++++++++++++++++ EU!");
    return "eu";
  } else if (in_na == -1) {
    console.log("+++++++++++++++++++++++++++++++++ NA!");
    return "na";
  } else if (in_as == -1) {
    console.log("+++++++++++++++++++++++++++++++++ AS!");
    return "as";
  } else if (in_aus == -1) {
    console.log("+++++++++++++++++++++++++++++++++ AUS!");
    return "aus";
  }

  return "global";
}

// async function getCountryCode(lon, lat) {

//   const reversed_geocod_url = `https://eu1.locationiq.com/v1/reverse.php?key=${loc_iq_key}&lat=${lat}&lon=${lon}&format=json`;

//   return await axios
//     .get(reversed_geocod_url)
//     .then((resp) => {
//       console.log(":: data geocoding", resp.data);
//       return resp.data.address.country_code;
//     })
//     .catch(function(error) {
//       if (error.response) {
//         // The request was made and the server responded with a status code
//         // that falls out of the range of 2xx
//         console.log(error.response.data);
//         console.log(error.response.status);
//         console.log(error.response.headers);
//       } else if (error.request) {
//         // The request was made but no response was received
//         // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//         // http.ClientRequest in node.js
//         console.log(error.request);
//       } else {
//         // Something happened in setting up the request that triggered an Error
//         console.log("Error", error.message);
//       }
//       console.log(error.config);
//       return "fr";
//     });
// }
